import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import api from '../api';
import { 
  FETCH_PAYMENTS,
} from 'constants/ActionTypes';
import { showPaymentsLoader, fetchPaymentsSuccess, showPaymentsMessage } from 'actions/Payments';
import { userSignOut } from 'actions/Auth';

function* getPayments({ payload }) {
  try {
    const { from, to, page, limit, lastEvaluatedKey } = payload
    yield put(showPaymentsLoader({page}));
    const authToken = localStorage.getItem('token');
    const payments = yield call(api.paymentsApi.getPayments, { authToken, from, to, page, limit, lastEvaluatedKey });

    if (payments.errorMessage) {
      yield put(showPaymentsMessage(payments.errorMessage, true));
    } else {
      yield put(fetchPaymentsSuccess(payments));
    }
  } catch (error) {
    console.log('error', error);
    yield put(showPaymentsMessage(error.message || error, true));
    yield put(userSignOut());
  }
}


export function* fetchPayments() {
  yield takeEvery(FETCH_PAYMENTS, getPayments);
}

export default function* rootSaga() {
  yield all([
    fork(fetchPayments)
  ]);
}



// WEBPACK FOOTER //
// ./sagas/Payments.js